import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/visualization",
  },
  {
    path: "/visualization",
    name: "visualization",
    component: () => import("../views/visualization.vue"),
  },
  // {
  //   path: '/',
  //   redirect: '/main'
  // },
  // {
  //   path: '/',
  //   redirect: '/index'
  // },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/main",
    name: "main",
    component: () => import("../views/main.vue"),
    redirect: "/main/weatherEquipment",
    children: [
      // {
      //   path: "/main/weather",
      //   name: "weather",
      //   component: () => import("../views/weather.vue")
      // },
      {
        path: "/main/weatherEquipment",
        name: "weatherEquipment",
        component: () => import("../views/weatherEquipment.vue"),
      },
      // {
      //   path: "/main/cqData",
      //   name: "cqData",
      //   component: () => import("../views/cqData.vue")
      // },
      {
        path: "/main/cqDataInfo",
        name: "cqDataInfo",
        component: () => import("../views/cqDataInfo.vue"),
      },
      // {
      //   path: "/main/manure",
      //   name: "manure",
      //   component: () => import("../views/manure.vue")
      // },
      {
        path: "/main/manureInfo",
        name: "manureInfo",
        component: () => import("../views/manureInfo.vue"),
      },
      {
        path: "/main/videoList",
        name: "videoList",
        component: () => import("../views/videoList.vue"),
      },
    ],
  },
];
const router = new VueRouter({
  routes,
});

export default router;
